// added with ♥ by Buzzwoo!

// assets/bw-predictive-search-tabs.js
(() => {
  // prevent double-binding if theme loads this twice
  if (window.__psTabsBound) return;
  window.__psTabsBound = true;

  function activateTab(tab) {
    const wrapper = tab.closest("[data-predictive-search-tabs]");
    if (!wrapper) return;

    const tabs = Array.from(wrapper.querySelectorAll('.predictive-search__tab[role="tab"]'));
    const panels = Array.from(wrapper.querySelectorAll('.predictive-search__tabpanel[role="tabpanel"]'));
    const panelId = tab.getAttribute("aria-controls");
    if (!panelId) return;

    tabs.forEach((t) => {
      const active = t === tab;
      t.classList.toggle("is-active", active);
      t.setAttribute("aria-selected", active ? "true" : "false");
      t.tabIndex = active ? 0 : -1;
    });

    panels.forEach((p) => {
      const active = p.id === panelId;
      if (active) p.removeAttribute("hidden");
      else p.setAttribute("hidden", "");
    });
  }

  document.addEventListener("click", (e) => {
    const tab = e.target.closest('.predictive-search__tab[role="tab"]');
    if (!tab) return;
    activateTab(tab);
  });

  // optional: keyboard left/right between tabs
  document.addEventListener("keydown", (e) => {
    const tab = e.target.closest('.predictive-search__tab[role="tab"]');
    if (!tab) return;
    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;

    const wrapper = tab.closest("[data-predictive-search-tabs]");
    if (!wrapper) return;

    const tabs = Array.from(wrapper.querySelectorAll('.predictive-search__tab[role="tab"]'));
    const idx = tabs.indexOf(tab);
    const nextIdx =
      e.key === "ArrowRight" ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;

    activateTab(tabs[nextIdx]);
    tabs[nextIdx].focus();
    e.preventDefault();
  });
})();
